import { Navigate } from 'react-router-dom'
import { useAuth } from '../Providers/AuthProvider'
import useCheckUserRole from './BasketPage/Hooks/useCheckUserRole.ts'
import NoAccess from './NoAccess'

// requirement to Permission albo { permission: Permission, minLevel: number }
// dla uprawnień poziomowanych (np. upR_SYS_OBSLUGA_KONTAKTOW: 0-4)
// przykład [Permission.Operator, { permission: Permission.CrmContacts, minLevel: 1 }]
const hasPermission = (user, requirement) => {
    const permission = requirement.permission ?? requirement
    const value = user[permission]

    if (requirement.minLevel !== undefined) {
        return Number(value) >= requirement.minLevel
    }
    if (typeof value === 'string' || typeof value === 'number') {
        return Number(value) > 0
    }
    return Boolean(value)
}

const RequireAuth = ({ permissions = [], roles = [], children }) => {
    const { authState } = useAuth()
    const { isUserHasAccess } = useCheckUserRole()

    if (!authState?.user) {
        return <Navigate to='/login' replace />
    }

    const hasAllPermissions = permissions.every(requirement => hasPermission(authState.user, requirement))
    const hasAllRoles = roles.every(role => isUserHasAccess(role))

    if (!hasAllPermissions || !hasAllRoles) {
        return <NoAccess />
    }

    return children
}

export default RequireAuth
